import type { SitrepSectionType } from 'components/DisasterGPT/hooks/useSitrepsV2';

export type SectionGroup = {
  category: string | null;
  sections: { section: SitrepSectionType; index: number }[];
};

/**
 * Groups sections under the category their template assigned them to, keeping
 * each section's index within the flat `sections` array so the active-index
 * contract is unchanged. Sections without a category fall into a single
 * trailing uncategorized group.
 *
 * Shared by `SitrepSectionTabs` (categories as tabs) and
 * `SitrepSectionDocumentView` (categories as a tree) so both layouts group
 * identically.
 */
export const groupSectionsByCategory = (
  sections: SitrepSectionType[]
): SectionGroup[] => {
  const groups: SectionGroup[] = [];

  sections.forEach((section, index) => {
    const category = section.category ?? null;
    const lastGroup = groups[groups.length - 1];

    if (lastGroup && lastGroup.category === category) {
      lastGroup.sections.push({ section, index });
    } else {
      groups.push({ category, sections: [{ section, index }] });
    }
  });

  return groups;
};

/** Whether any section carries a template category. */
export const sectionsHaveCategories = (
  sections: SitrepSectionType[]
): boolean => sections.some((section) => (section.category ?? null) !== null);
